import type { PageLoad } from "./$types";
import type { PlaceType } from "../../../types";
import { error } from "@sveltejs/kit";
import { parseId } from "../../../params/slug";
import { filter } from "lodash-es";

export const load: PageLoad = async function ({ params, parent }) {
  const id = parseId(params.id);

  const { placeTypes, places, placeHoursGroups } = await parent();

  const placeType = placeTypes.find((i: PlaceType) => i.id == id);

  if (placeType == null) {
    error(404, `Unable to find place type: ${id}`);
  }

  return {
    places: places,
    placeType: placeType,
    children: filter(placeTypes, { parentId: id }) as PlaceType[],
    placeHoursGroups: placeHoursGroups,
    pageTitle: placeType.label,
    pageDescription: `All places categorized by ${placeType.label}`
  };
};
